// DS: MO3.4.1
import React from 'react';
import { PapiDeviation } from '@wix/da-papi-types';
import DeviationShopCard, { type DeviationShopCardProps } from '../DeviationShopCard';

interface Props extends Pick<DeviationShopCardProps, 'allowedIndicators'> {
  deviation: PapiDeviation;
  width: number;
  withAuthorDetails?: boolean;
  withDreamupLabel?: boolean;
}

const PCPShopCard: React.FC<Props> = ({
  width,
  deviation,
  withAuthorDetails,
  allowedIndicators,
  withDreamupLabel,
}) => {
  return (
    <DeviationShopCard
      width={width}
      deviation={deviation}
      withStats={true}
      withPremiumDownloadCount={true}
      withDescriptionBlock={false}
      withAuthorDetails={withAuthorDetails}
      allowedIndicators={allowedIndicators}
      withDreamupLabel={withDreamupLabel}
    />
  );
};
PCPShopCard.displayName = 'PCPShopCard';

export default PCPShopCard;
